import { Box, InputAdornment, TextField, useMediaQuery } from "@mui/material";
import SearchIcon from "../IconComp/searchIcon";
interface IProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  title: string;
  width?: number;
  height?: string;
}

const SearchField = ({ width, searchQuery, setSearchQuery, title, height }: IProps) => {
  const isSm = useMediaQuery((theme: any) => theme.breakpoints.down("sm"));
  const isMd = useMediaQuery((theme: any) => theme.breakpoints.down("md"));
  const responsiveWidth = isSm ? "100%" : isMd ? "250px" : width || "350px";

  return (
    <Box>
      <TextField
        placeholder={title}
        variant="outlined"
        size="small"
        value={searchQuery}
        onChange={(e: any) => setSearchQuery(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        sx={{ width: responsiveWidth, ...(height && { height: height }) }}
      />
    </Box>
  );
};

export default SearchField;
